import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { CLOSE_OBSERVER } from "./actionTypes";
import { observerError, resetObserver } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* closeObserver({ payload: chatId }) {
  try {
    const response = yield call(
      axios.get,
      `${
        process.env.REACT_APP_MESSAGES_API_URL
      }/tech4h-messages/conversation/observer/stop${
        chatId ? "?id=" + chatId : ""
      }`
    );

    if (response.status === 200) {
      yield put(resetObserver());
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Close observer error";
    yield put(observerError({ action: "close_observer", message: message }));
  }
}

export function* watchCloseObserver() {
  yield takeEvery(CLOSE_OBSERVER, closeObserver);
}
function* authSaga() {
  yield all([fork(watchCloseObserver)]);
}

export default authSaga;
